module.exports = __webpack_public_path__ + "static/img/3icon.f5e60f24.png";